import React from 'react';
import { View } from 'react-native';

import ThemeStyle from '../../Theme/styles';

type Props = {
  style?: any;
};

const CellRenderrer = ({ children, style }: React.PropsWithChildren<Props>) => {
  return <View style={[ThemeStyle.flex1, style]} children={children} />;
};

export default CellRenderrer;
